import { forwardRef } from "react";
import { ICONS, type IconName } from "./icons";
import { cn } from "@/lib/styles.utils";

export type IconProps = React.SVGProps<SVGSVGElement> & {
  name: IconName;
  className?: string;
  role?: React.AriaRole;
};

export const Icon = forwardRef<SVGSVGElement, IconProps>(function Icon(
  { name, className, role = "img", ...rest },
  ref,
) {
  const Path = ICONS[name];

  const viewBox = (): string => {
    const doubleZero = "0 0";
    switch (name) {
      case "backArrow":
      case "errorX":
      case "success":
      case "downloadPdf":
      case "engine":
      case "checkedFolder":
      case "closeEmptyCircle":
      case "rotateArrows":
      case "sortArrows":
      case "okCheck":
      case "exit":
        return `${doubleZero} 16 16`;
      case "wrench":
      case "industrialUnit":
      case "filingDrawer":
      case "addPicture":
      case "senddingBox":
        return `${doubleZero} 32 32`;
      case "home":
        return `${doubleZero} 18 15`;
      default:
        return `${doubleZero} 24 24`;
    }
  };

  return (
    <svg
      data-testid={`icon-${name}`}
      ref={ref}
      viewBox={viewBox()}
      xmlns="http://www.w3.org/2000/svg"
      role={role}
      className={cn(!className?.includes("size-") ? "size-6" : "", className)}
      {...rest}
    >
      {Path}
    </svg>
  );
});
